import { supabase } from '../lib/supabase';

export const vetrineContentService = {
  // =====================================================
  // PRODUCTS
  // =====================================================
  async getProductsByStore(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_products')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.eq('disponibile', true)
      ?.order('ordine', { ascending: true });

    if (error) throw error;
    return data?.map(this.convertProductToCamelCase) || [];
  },

  async createProduct(productData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertProductToSnakeCase(productData);
    dbData.created_by_admin = user?.id;
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_products')
      ?.insert(dbData)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertProductToCamelCase(data);
  },

  async updateProduct(productId, productData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertProductToSnakeCase(productData);
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_products')
      ?.update(dbData)
      ?.eq('id', productId)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertProductToCamelCase(data);
  },

  async deleteProduct(productId) {
    const { error } = await supabase
      ?.from('vetrine_products')
      ?.delete()
      ?.eq('id', productId);

    if (error) throw error;
  },

  // =====================================================
  // SERVICES
  // =====================================================
  async getServicesByStore(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_services')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.order('ordine', { ascending: true });

    if (error) throw error;
    return data?.map(this.convertServiceToCamelCase) || [];
  },

  async createService(serviceData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertServiceToSnakeCase(serviceData);
    dbData.created_by_admin = user?.id;
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_services')
      ?.insert(dbData)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertServiceToCamelCase(data);
  },

  async updateService(serviceId, serviceData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertServiceToSnakeCase(serviceData);
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_services')
      ?.update(dbData)
      ?.eq('id', serviceId)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertServiceToCamelCase(data);
  },

  async deleteService(serviceId) {
    const { error } = await supabase
      ?.from('vetrine_services')
      ?.delete()
      ?.eq('id', serviceId);

    if (error) throw error;
  },

  // =====================================================
  // PROMOTIONS WITH CALENDAR
  // =====================================================
  async getPromotionsByStore(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_promo_calendar')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.order('data_inizio', { ascending: false });

    if (error) throw error;
    return data?.map(this.convertPromotionToCamelCase) || [];
  },

  async getActivePromotions(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_promo_calendar')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.eq('stato', 'attiva')
      ?.order('data_inizio', { ascending: false });

    if (error) throw error;
    return data?.map(this.convertPromotionToCamelCase) || [];
  },

  async createPromotion(promotionData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertPromotionToSnakeCase(promotionData);
    dbData.created_by_admin = user?.id;
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_promo_calendar')
      ?.insert(dbData)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertPromotionToCamelCase(data);
  },

  async updatePromotion(promotionId, promotionData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertPromotionToSnakeCase(promotionData);
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_promo_calendar')
      ?.update(dbData)
      ?.eq('id', promotionId)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertPromotionToCamelCase(data);
  },

  async deletePromotion(promotionId) {
    const { error } = await supabase
      ?.from('vetrine_promo_calendar')
      ?.delete()
      ?.eq('id', promotionId);

    if (error) throw error;
  },

  async updatePromotionStatus() {
    const { error } = await supabase?.rpc('update_promo_status');
    if (error) throw error;
  },

  // =====================================================
  // CASHBACK OFFERS
  // =====================================================
  async getCashbackOffersByStore(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_cashback_offers')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(this.convertCashbackToCamelCase) || [];
  },

  async getActiveCashbackOffers(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_cashback_offers')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.eq('stato', 'attiva')
      ?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(this.convertCashbackToCamelCase) || [];
  },

  async createCashbackOffer(cashbackData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertCashbackToSnakeCase(cashbackData);
    dbData.created_by_admin = user?.id;
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_cashback_offers')
      ?.insert(dbData)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertCashbackToCamelCase(data);
  },

  async updateCashbackOffer(cashbackId, cashbackData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertCashbackToSnakeCase(cashbackData);
    dbData.updated_by_admin = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_cashback_offers')
      ?.update(dbData)
      ?.eq('id', cashbackId)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertCashbackToCamelCase(data);
  },

  async deleteCashbackOffer(cashbackId) {
    const { error } = await supabase
      ?.from('vetrine_cashback_offers')
      ?.delete()
      ?.eq('id', cashbackId);

    if (error) throw error;
  },

  // =====================================================
  // REVIEWS
  // =====================================================
  async getReviewsByStore(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_reviews')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.eq('stato', 'approvata')
      ?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(this.convertReviewToCamelCase) || [];
  },

  async getAllReviewsByStore(storeId) {
    const { data, error } = await supabase
      ?.from('vetrine_reviews')
      ?.select('*')
      ?.eq('store_id', storeId)
      ?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(this.convertReviewToCamelCase) || [];
  },

  async createReview(reviewData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Non autenticato');

    const dbData = this.convertReviewToSnakeCase(reviewData);
    dbData.user_id = user?.id;

    const { data, error } = await supabase
      ?.from('vetrine_reviews')
      ?.insert(dbData)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertReviewToCamelCase(data);
  },

  async updateReview(reviewId, reviewData) {
    const dbData = this.convertReviewToSnakeCase(reviewData);

    const { data, error } = await supabase
      ?.from('vetrine_reviews')
      ?.update(dbData)
      ?.eq('id', reviewId)
      ?.select()
      ?.single();

    if (error) throw error;
    return this.convertReviewToCamelCase(data);
  },

  async deleteReview(reviewId) {
    const { error } = await supabase
      ?.from('vetrine_reviews')
      ?.delete()
      ?.eq('id', reviewId);

    if (error) throw error;
  },

  async approveReview(reviewId) {
    return this.updateReview(reviewId, { stato: 'approvata' });
  },

  async rejectReview(reviewId) {
    return this.updateReview(reviewId, { stato: 'rifiutata' });
  },

  // =====================================================
  // CONVERSION HELPERS - PRODUCTS
  // =====================================================
  convertProductToCamelCase(row) {
    if (!row) return null;
    return {
      id: row?.id,
      storeId: row?.store_id,
      nome: row?.nome,
      descrizione: row?.descrizione,
      categoria: row?.categoria,
      prezzo: row?.prezzo,
      prezzoScontato: row?.prezzo_scontato,
      immagine: row?.immagine,
      disponibile: row?.disponibile,
      nuovo: row?.nuovo,
      inEvidenza: row?.in_evidenza,
      ordine: row?.ordine,
      createdByAdmin: row?.created_by_admin,
      updatedByAdmin: row?.updated_by_admin,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    };
  },

  convertProductToSnakeCase(data) {
    const snakeData = {};
    if (data?.storeId !== undefined) snakeData.store_id = data?.storeId;
    if (data?.nome !== undefined) snakeData.nome = data?.nome;
    if (data?.descrizione !== undefined) snakeData.descrizione = data?.descrizione;
    if (data?.categoria !== undefined) snakeData.categoria = data?.categoria;
    if (data?.prezzo !== undefined) snakeData.prezzo = data?.prezzo;
    if (data?.prezzoScontato !== undefined) snakeData.prezzo_scontato = data?.prezzoScontato;
    if (data?.immagine !== undefined) snakeData.immagine = data?.immagine;
    if (data?.disponibile !== undefined) snakeData.disponibile = data?.disponibile;
    if (data?.nuovo !== undefined) snakeData.nuovo = data?.nuovo;
    if (data?.inEvidenza !== undefined) snakeData.in_evidenza = data?.inEvidenza;
    if (data?.ordine !== undefined) snakeData.ordine = data?.ordine;
    return snakeData;
  },

  // =====================================================
  // CONVERSION HELPERS - SERVICES
  // =====================================================
  convertServiceToCamelCase(row) {
    if (!row) return null;
    return {
      id: row?.id,
      storeId: row?.store_id,
      nome: row?.nome,
      descrizione: row?.descrizione,
      categoria: row?.categoria,
      prezzo: row?.prezzo,
      durata: row?.durata,
      disponibilita: row?.disponibilita,
      caratteristiche: row?.caratteristiche,
      icona: row?.icona,
      inEvidenza: row?.in_evidenza,
      ordine: row?.ordine,
      createdByAdmin: row?.created_by_admin,
      updatedByAdmin: row?.updated_by_admin,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    };
  },

  convertServiceToSnakeCase(data) {
    const snakeData = {};
    if (data?.storeId !== undefined) snakeData.store_id = data?.storeId;
    if (data?.nome !== undefined) snakeData.nome = data?.nome;
    if (data?.descrizione !== undefined) snakeData.descrizione = data?.descrizione;
    if (data?.categoria !== undefined) snakeData.categoria = data?.categoria;
    if (data?.prezzo !== undefined) snakeData.prezzo = data?.prezzo;
    if (data?.durata !== undefined) snakeData.durata = data?.durata;
    if (data?.disponibilita !== undefined) snakeData.disponibilita = data?.disponibilita;
    if (data?.caratteristiche !== undefined) snakeData.caratteristiche = data?.caratteristiche;
    if (data?.icona !== undefined) snakeData.icona = data?.icona;
    if (data?.inEvidenza !== undefined) snakeData.in_evidenza = data?.inEvidenza;
    if (data?.ordine !== undefined) snakeData.ordine = data?.ordine;
    return snakeData;
  },

  // =====================================================
  // CONVERSION HELPERS - PROMOTIONS
  // =====================================================
  convertPromotionToCamelCase(row) {
    if (!row) return null;
    return {
      id: row?.id,
      storeId: row?.store_id,
      titolo: row?.titolo,
      descrizione: row?.descrizione,
      tipo: row?.tipo,
      valoreSconto: row?.valore_sconto,
      condizioni: row?.condizioni,
      dataInizio: row?.data_inizio,
      dataFine: row?.data_fine,
      stato: row?.stato,
      immagine: row?.immagine,
      coloreBadge: row?.colore_badge,
      visualizzazioni: row?.visualizzazioni,
      click: row?.click,
      conversioni: row?.conversioni,
      inEvidenza: row?.in_evidenza,
      createdByAdmin: row?.created_by_admin,
      updatedByAdmin: row?.updated_by_admin,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    };
  },

  convertPromotionToSnakeCase(data) {
    const snakeData = {};
    if (data?.storeId !== undefined) snakeData.store_id = data?.storeId;
    if (data?.titolo !== undefined) snakeData.titolo = data?.titolo;
    if (data?.descrizione !== undefined) snakeData.descrizione = data?.descrizione;
    if (data?.tipo !== undefined) snakeData.tipo = data?.tipo;
    if (data?.valoreSconto !== undefined) snakeData.valore_sconto = data?.valoreSconto;
    if (data?.condizioni !== undefined) snakeData.condizioni = data?.condizioni;
    if (data?.dataInizio !== undefined) snakeData.data_inizio = data?.dataInizio;
    if (data?.dataFine !== undefined) snakeData.data_fine = data?.dataFine;
    if (data?.stato !== undefined) snakeData.stato = data?.stato;
    if (data?.immagine !== undefined) snakeData.immagine = data?.immagine;
    if (data?.coloreBadge !== undefined) snakeData.colore_badge = data?.coloreBadge;
    if (data?.inEvidenza !== undefined) snakeData.in_evidenza = data?.inEvidenza;
    return snakeData;
  },

  // =====================================================
  // CONVERSION HELPERS - CASHBACK
  // =====================================================
  convertCashbackToCamelCase(row) {
    if (!row) return null;
    return {
      id: row?.id,
      storeId: row?.store_id,
      titolo: row?.titolo,
      descrizione: row?.descrizione,
      tipo: row?.tipo,
      valore: row?.valore,
      importoMinimo: row?.importo_minimo,
      importoMassimo: row?.importo_massimo,
      condizioni: row?.condizioni,
      dataInizio: row?.data_inizio,
      dataFine: row?.data_fine,
      stato: row?.stato,
      utilizziTotali: row?.utilizzi_totali,
      cashbackErogato: row?.cashback_erogato,
      inEvidenza: row?.in_evidenza,
      createdByAdmin: row?.created_by_admin,
      updatedByAdmin: row?.updated_by_admin,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    };
  },

  convertCashbackToSnakeCase(data) {
    const snakeData = {};
    if (data?.storeId !== undefined) snakeData.store_id = data?.storeId;
    if (data?.titolo !== undefined) snakeData.titolo = data?.titolo;
    if (data?.descrizione !== undefined) snakeData.descrizione = data?.descrizione;
    if (data?.tipo !== undefined) snakeData.tipo = data?.tipo;
    if (data?.valore !== undefined) snakeData.valore = data?.valore;
    if (data?.importoMinimo !== undefined) snakeData.importo_minimo = data?.importoMinimo;
    if (data?.importoMassimo !== undefined) snakeData.importo_massimo = data?.importoMassimo;
    if (data?.condizioni !== undefined) snakeData.condizioni = data?.condizioni;
    if (data?.dataInizio !== undefined) snakeData.data_inizio = data?.dataInizio;
    if (data?.dataFine !== undefined) snakeData.data_fine = data?.dataFine;
    if (data?.stato !== undefined) snakeData.stato = data?.stato;
    if (data?.inEvidenza !== undefined) snakeData.in_evidenza = data?.inEvidenza;
    return snakeData;
  },

  // =====================================================
  // CONVERSION HELPERS - REVIEWS
  // =====================================================
  convertReviewToCamelCase(row) {
    if (!row) return null;
    return {
      id: row?.id,
      storeId: row?.store_id,
      userId: row?.user_id,
      nomeUtente: row?.nome_utente,
      rating: row?.rating,
      titolo: row?.titolo,
      commento: row?.commento,
      rispostaNegozio: row?.risposta_negozio,
      rispostaData: row?.risposta_data,
      stato: row?.stato,
      verificata: row?.verificata,
      utileCount: row?.utile_count,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    };
  },

  convertReviewToSnakeCase(data) {
    const snakeData = {};
    if (data?.storeId !== undefined) snakeData.store_id = data?.storeId;
    if (data?.nomeUtente !== undefined) snakeData.nome_utente = data?.nomeUtente;
    if (data?.rating !== undefined) snakeData.rating = data?.rating;
    if (data?.titolo !== undefined) snakeData.titolo = data?.titolo;
    if (data?.commento !== undefined) snakeData.commento = data?.commento;
    if (data?.rispostaNegozio !== undefined) snakeData.risposta_negozio = data?.rispostaNegozio;
    if (data?.rispostaData !== undefined) snakeData.risposta_data = data?.rispostaData;
    if (data?.stato !== undefined) snakeData.stato = data?.stato;
    if (data?.verificata !== undefined) snakeData.verificata = data?.verificata;
    return snakeData;
  }
};